import styled from 'styled-components';

export const StyledPagination = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  color: rgb(158, 158, 158);
  font-size: 13px;
  text-align: right;
  padding: 12px 12px 12px 20px;

  .page {
    margin-right: 30px;
  }

  .pages {
    margin-right: 30px;
  }

  .arrow {
    font-size: 16px;
    font-weight: bold;
    color: rgb(158, 158, 158);
  }
`;

export const StyledLinesPerPageSection = styled.div`
  display: inline-flex;
  height: 38px;
  width: fit-content;
  gap: 8px;
  align-items: center;

  span {
    text-align: justify;
  }
`

export const StyledPagesSection = styled.div``

export const StyledButton = styled.button<{ width?: string; height?: string }>`
  border: 0;
  outline: 0;
  cursor: pointer;
  width: ${props => props.width ? `${props.width}px` : '130px'};
  height: ${props => props.height ? `${props.height}px` : '40px'};
  background-color: transparent;

  &:disabled {
    opacity: .5;
    cursor: not-allowed;
  }

  &.TextRed {
    text-transform: uppercase;
    color: #f16666;
  }

  &.Primary {
    color: var(--color-contrast-white);
    background-color: #139c8c;
  }

  &.XmlNF {
    color: #000000;
    border-radius: 2px;
    border: solid 1px var(--color-neutral-300);
    background-color: var(--color-contrast-white);
    display: inline-block;
    vertical-align: top;
    flex-direction: column;
    align-items: center;
    padding-top: 6px;
    margin-right: 10px;
  }
`;